import { useLocation } from 'react-router-dom'

/** Small static branding mark — decorative, low visual weight (hidden on home; footer owns Illust there). */
export const IllustMark = () => {
  const { pathname } = useLocation()
  if (pathname === '/') return null

  return (
    <div className="mem-illust-mark" aria-hidden="true" title="illust.">
      <img src="/illust-logo.png" alt="" decoding="async" className="mem-illust-mark__img" />
    </div>
  )
}
